import axios from "axios";
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

export const schema = Joi.object().keys({
  cName: Joi.string().required(),
  cType: Joi.number().integer().allow(''),
  feeType: Joi.number().integer().allow(''),
  consumption_type: Joi.number().integer().required(''),
  totalPrice: Joi.number().allow(''),
  unitPrice: Joi.number().allow(''),
  totalQuantity: Joi.number().integer().allow(''),
  maxStudentsNumber: Joi.number().integer().allow(''),
  cAddress: Joi.string().allow(''),
  costRule: Joi.number().integer().allow(''),
  costAlertRange: Joi.number().integer().allow(''),
  absentFlag: Joi.number().integer().allow(''),
  cancelFlag: Joi.number().integer().allow(''),
  student_id_list: Joi.array().allow(''),
  teacher_id_list: Joi.array().allow(''),
});

export default function editClass(classId, classInfo) {
  if(!classId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing class ID')
      })
    })
	}

  let validateResult = Joi.validate(classInfo, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

	return new Promise((resolve, reject) => {
		axios.put(APIAddress, {'uri': `/u_cls/${classId}/`,
    'data': JSON.stringify(classInfo),
    'method': 'PUT',
    'token': localStorage.getItem('token')})
    .then((res) => {
			resolve(res.data);
		})
		.catch((err) => {
			reject(err);
		})
	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/class/editClass.js